'use client'

import { FacilitatorImageSection } from './FacilitatorProfileEditor'

export function FacilitatorImageSectionWrapper({
  facilitatorName,
  wellnessImages,
}: {
  facilitatorName: string
  wellnessImages: string[]
}) {
  return (
    <div className="lg:col-span-1 bg-white rounded-xl p-6 shadow-sm border border-border">
      <FacilitatorImageSection facilitatorName={facilitatorName} />
    </div>
  )
}

